/*
 * Copyright 2026 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/kmp-project-template/blob/main/LICENSE
 */
package kpt.core.store.cloudtodo.impl

/**
 * Single-todo Store5 key (jsonplaceholder addresses todos by numeric id).
 *
 * @property id jsonplaceholder's numeric todo id.
 */
data class CloudTodoKey(val id: Int)
